import { render, staticRenderFns } from "./textBookDialogPartner.vue?vue&type=template&id=a40b42de&scoped=true"
import script from "./textBookDialogPartner.vue?vue&type=script&lang=js"
export * from "./textBookDialogPartner.vue?vue&type=script&lang=js"
import style0 from "./textBookDialogPartner.vue?vue&type=style&index=0&id=a40b42de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40b42de",
  null
  
)

export default component.exports